import {sendRequest} from "./Sender";
import {useDispatch, useSelector} from "react-redux";
import {setDepartment, setDepartments, userLogout, userUpdateInfo} from "../actions/user";
import {useNavigate} from "react-router-dom";
import {ClientService} from "./ClientService";

export const userService = {
    Auth,
    Logout,
    UpdateInfo,
    GetCurrentDepartment,
    SetCurrentDepartment,
    GetAllDepartments
}

function Auth(token){
    localStorage.setItem('user', token);
}

function Logout(){
    localStorage.removeItem('user');
}

function GetCurrentDepartment(){
    return JSON.parse(localStorage.getItem('currentDepartment'))
}

function SetCurrentDepartment(department){
    localStorage.setItem('currentDepartment', department)
    // const dispatch = useDispatch()
    // dispatch(setDepartment(department))
}

function UpdateInfo(){
    const dispatch = useDispatch()
    // dispatch(userUpdateInfo({
    //     id: 1,
    //     name: 1,
    //     client_id: 1
    // }))

    ClientService.GetList().then((rows) => {
        dispatch(userUpdateInfo( {
            id: 1,
            name: 1,
            client_id: rows.items[0].id
        }))

    })

    return true
    sendRequest('getUserInfo', 'GET', {
        token: localStorage.getItem('user')
    }).then(response => {

        if (response) {
            dispatch(userUpdateInfo(response))
            return true;
        } else {
            Logout();
            dispatch(userLogout())
        }
    })

}

function GetAllDepartments(){
    return sendRequest('clients', 'GET', {}, true)
}